import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Homepage from "./Pages/HomePage.js";
import LoginForm from "./Pages/LoginForm.js";
import ForgotPassword from "./Pages/ForgotPassword.js";
import ResetPasswordPage from "./Pages/ResetPasswordPage.js";
import ResetPasswordSuccess from "./Pages/ResetPasswordSuccess.js";
import { isSessionValid, clearSession } from "./Constant/auth.js";

function App() {
  // Boolean(localStorage.getItem("isLogged")) used to treat even the string
  // "false" - and any expired session - as logged in.
  const isLoggedIn = isSessionValid();
  if (!isLoggedIn && localStorage.getItem("isLogged")) {
    // Stale session left behind by an expired token
    clearSession();
  }

window.onerror = function (message, source, lineno, colno, error) {
  console.error("Global Error:", { message, source, lineno, colno, error });
};
window.addEventListener('error', function (e) {
  console.error("Caught by eventListener", e);
});

  return (
    <Router>
      <Routes>
        {isLoggedIn ? (
          <>
            <Route path="/scancam-edge/home" element={<Homepage />} />
            <Route path="*" element={<Navigate to="/scancam-edge/home" />} />
          </>
        ) : (
          <>
            <Route path="/scancam-edge/login" element={<LoginForm />} />
            <Route path="/scancam-edge/forgotpassword" element={<ForgotPassword />} />
            <Route path="/scancam-edge/resetpasswordsuccess" element={<ResetPasswordSuccess />} />

            {/* Define route with parameters */}
            <Route
              path="/scancam-edge/resetpassword/:custId/:name/:resetToken"
              element={<ResetPasswordPage />}
            />

            <Route path="*" element={<Navigate to="/scancam-edge/login" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
